// @flow

import { addToCartDocumentation } from './default/addToCartDocumentation'
import { addToCartDrJoseph } from './drjoseph/addToCartDrJoseph'
import { addToCartKiehls } from './kiehls/addToCartKiehls'
import { addToCartLancome } from './lancome/addToCartLancome'
import { addToCartPetsdeli } from './petsdeli/addToCartPetsdeli'
import { addToCartVitaminExpress } from './vitaminexpress/addToCartVitaminExpress'
import { addToCartShopify } from './shopify/addToCartShopify'
import { addToCartSkinceuticalsByLocale } from './skinceuticals/addToCartSkinceuticalsByLocale'
import { addToCartJeanAndLen } from './jeanandlen/addToCartJeanAndLen'
import { SHOPS } from './shops'

export const ADD_TO_CART_FUNCTIONS: any = {
  [SHOPS.BAERBEL_DREXEL_CUSTOMER_ID]: addToCartVitaminExpress,
  [SHOPS.BIOTHERM_CUSTOMER_ID]: addToCartKiehls,
  [SHOPS.DR_JOSEPH_CUSTOMER_ID]: addToCartDrJoseph,
  [SHOPS.DR_JOSEPH_EN_CUSTOMER_ID]: addToCartDrJoseph,
  [SHOPS.DR_JOSEPH_IT_CUSTOMER_ID]: addToCartDrJoseph,
  [SHOPS.KIEHLS_CUSTOMER_ID]: addToCartKiehls,
  [SHOPS.KIEHLS_DK_CUSTOMER_ID]: addToCartKiehls,
  [SHOPS.KIEHLS_NO_CUSTOMER_ID]: addToCartKiehls,
  [SHOPS.KIEHLS_SE_CUSTOMER_ID]: addToCartKiehls,
  [SHOPS.LANCOME_CUSTOMER_ID]: addToCartLancome,
  [SHOPS.SKINCEUTICALS_CUSTOMER_ID]: addToCartSkinceuticalsByLocale('de_DE'),
  [SHOPS.SKINCEUTICALS_NL_CUSTOMER_ID]: addToCartSkinceuticalsByLocale('nl_NL'),
  [SHOPS.PETSDELI_CATS_CUSTOMER_ID]: addToCartPetsdeli,
  [SHOPS.PETSDELI_DOGS_CUSTOMER_ID]: addToCartPetsdeli,
  [SHOPS.VITAMINEXPRESS_CUSTOMER_ID]: addToCartVitaminExpress,
  [SHOPS.VITAMINEXPRESS_UK_CUSTOMER_ID]: addToCartVitaminExpress,
  [SHOPS.TEST_SHOPIFY_STORE_CUSTOMER_ID]: addToCartShopify,
  [SHOPS.SKINCEUTICALS_CH_DE_CUSTOMER_ID]: addToCartSkinceuticalsByLocale('de_CH'),
  [SHOPS.SKINCEUTICALS_CH_FR_CUSTOMER_ID]: addToCartSkinceuticalsByLocale('fr_CH'),
  [SHOPS.JEAN_AND_LEN_CUSTOMER_ID]: addToCartJeanAndLen,
  [SHOPS.JEAN_AND_LEN_EN_CUSTOMER_ID]: addToCartJeanAndLen,
  [SHOPS.JEAN_AND_LEN_TESTING_CUSTOMER_ID]: addToCartJeanAndLen,
  [SHOPS.JEAN_AND_LEN_TEMP_CUSTOMER_ID]: addToCartJeanAndLen
}

export function geAddToCartFunction (customerId: string): Function {
  return ADD_TO_CART_FUNCTIONS[customerId] ?? addToCartDocumentation
}
